import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals.ts';

import ActionContextProvider from './context/actionContext.tsx';
import { ImageContextProvider } from './context/imageContext.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ActionContextProvider>
      <ImageContextProvider>
        <App />
      </ImageContextProvider>
    </ActionContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
